/** magic values for reactflow that cause it to auto-layout nodes */
export const TREE_GRAPH_AUTO_LAYOUT_POSITION = { x: 0, y: 0 };
/** the default edge thickness for the graph */
export const DEFAULT_EDGE_THICKNESS = 1;
